import styled from "@emotion/styled/macro";
import { colors, views } from "../../../../common/styles/theme.styles";
import { ItemSelectedCheckboxWrapper } from "../../../wealth/pages/class/components/ClassPage.styles";

export const VaultListWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
`;

export const VaultListHeader = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    height: 48px;
    padding: 8px 4px 8px 0;
    align-items: center;
    justify-content: space-between;

    color: var(--Dark-Gray-3, #9097A3);
    font-size: 12px;
    font-style: normal;
    font-weight: 450;
    line-height: normal;

    border-bottom: 1px solid var(--Main-Colors-Light-Grey-2, #F1F3F5);
`;

export const VaultListHeaderSortButton = styled.div`
    display: flex;
    padding: 8px 8px 8px 12px;
    align-items: center;
    gap: 4px;

    border-radius: 8px;
    color: var(--Dark-Gray-2, #585D66);
    border: 1px solid transparent;

    cursor: pointer;

    &:hover {
        border: 1px solid ${colors.gray3};
    }
`;

export const VaultListHeaderSortDirectionButton = styled.div`
    display: flex;
    width: 20px;
    height: 20px;
    padding: 2px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;

    border-radius: 20px;

    &:hover {
        background: var(--Main-Colors-Light-Grey-2, #F1F3F5);
    }

    ${({ sortDirection }) => (sortDirection === -1) && `
        transform: rotate(180deg);
    `}

    user-select: none;
`;

export const VaultListItemsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    ${({ isEmptyState }) => isEmptyState && `
        gap: 10px;
        padding-inline: 24px;
    `}
`;

export const VaultListFooterWrapper = styled.div`
    display: flex;
    width: 100%;
    padding: 16px 4px 0 8px;
    align-items: center;
    gap: 8px;

    color: var(--Dark-Gray-2, #585D66);
    font-size: 12px;
    font-style: normal;
    font-weight: 450;
    line-height: normal;

    border-top: 1px solid var(--Main-Colors-Light-Grey-2, #F1F3F5);
`;

export const VaultListFooterPagination = styled.div`
    display: flex;
    height: 36px;
    align-items: center;

    border-radius: 12px;
    border: 1px solid #D1D4DA;
`;

export const VaultListFooterPaginationButton = styled.div`
    display: flex;
    padding: 0px 8px;
    align-items: center;
    gap: 10px;
    align-self: stretch;

    cursor: pointer;
`;

export const VaultListFooterPaginationButtonLeft = styled(VaultListFooterPaginationButton)`
    transform: rotate(180deg);
    &:hover {
        ${({ disabled }) => !disabled && `
            background: ${colors.lightGray1};
            border-radius: 0 12px 12px 0;
        `}
    }
`;

export const VaultListFooterPaginationButtonRight = styled(VaultListFooterPaginationButton)`
    border-left: 1px solid ${colors.gray3};
    &:hover {
        ${({ disabled }) => !disabled && `
            background: ${colors.lightGray1};
            border-radius: 0 12px 12px 0;
        `}
    }
`;

export const VaultListFooterPaginationButtonIconWrapper = styled.div`
    display: flex;
    width: 24px;
    height: 24px;
    padding: 7.987px 0px 7.986px 0px;
    justify-content: center;
    align-items: center;

    ${({ disabled }) => disabled && `
        opacity: 0.3;
        cursor: default;
        pointer-events: none;
    `}
`;

export const VaultItemSelectedCheckboxWrapper = styled(ItemSelectedCheckboxWrapper)`
    margin-left: 0;
    opacity: 1;
    padding: 12px 8px;
    
    ${views.tablet} {
        .asset-vault-tab-wrapper & {
            display: none;
        }
    }
`
